import req from '../req'
// 群sop
export function getSopList (params) {
  return req.get('/salesperson/sop/list', params)
}
// 获取群sop详情
export function getSopDetail (id) {
  return req.get('/salesperson/sop/detail/' + id)
}

//移除规则
export function sopBindChat (id, params) {
  return req.post('/salesperson/sop/bind-chat/' + id, params)
}

//创建规则/endapi/salesperson/sop/create
export function createSop (params) {
  return req.post('/salesperson/sop/create', params)
}

//更新规则
export function updateSop (id, params) {
  return req.post('/salesperson/sop/update/' + id, params)
}

//更新状态
export function updateStatus (id, params) {
  return req.post('/salesperson/sop/update-status/' + id, params)
}
